export default __webpack_public_path__ + "static/media/802.d776e707.png";